import { render } from "./TotalIncome.vue?vue&type=template&id=dc5a8172"
import script from "./TotalIncome.vue?vue&type=script&lang=js"
export * from "./TotalIncome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__